const backupPermissions = [
  {
    id: 1,
    name: "View_Admins",
    description: "Permission to view admin users",
    type: "Admin Management",
    dependencies: []
  },
  {
    id: 2,
    name: "Create_Admin",
    description: "Permission to create new admin users",
    type: "Admin Management",
    dependencies: ["View_Admins"]
  },
  {
    id: 3,
    name: "Edit_Admin",
    description: "Permission to edit admin user details",
    type: "Admin Management",
    dependencies: ["View_Admins"]
  },
  {
    id: 4,
    name: "Delete_Admin",
    description: "Permission to delete admin users",
    type: "Admin Management",
    dependencies: ["View_Admins"]
  },
  {
    id: 5,
    name: "View_Clients",
    description: "Permission to view client users",
    type: "Client Management",
    dependencies: []
  },
  {
    id: 6,
    name: "Create_Client",
    description: "Permission to create new client users",
    type: "Client Management",
    dependencies: ["View_Clients"]
  },
  {
    id: 7,
    name: "Edit_Client",
    description: "Permission to edit client user details",
    type: "Client Management",
    dependencies: ["View_Clients"]
  },
  {
    id: 8,
    name: "Delete_Client",
    description: "Permission to delete client users",
    type: "Client Management",
    dependencies: ["View_Clients"]
  },
  {
    id: 9,
    name: "Manage_Client_Status",
    description: "Permission to suspend or activate client accounts",
    type: "Client Management",
    dependencies: ["View_Clients"]
  },
  {
    id: 10,
    name: "View_Sender_Ids",
    description: "Permission to view sender IDs",
    type: "Sender ID Management",
    dependencies: []
  },
  {
    id: 11,
    name: "Manage_Sender_Ids",
    description: "Permission to create, edit, delete, approve, and reject sender IDs",
    type: "Sender ID Management",
    dependencies: ["View_Sender_Ids"]
  },
  {
    id: 12,
    name: "View_Roles",
    description: "Permission to view user roles",
    type: "Role & Permission Management",
    dependencies: []
  },
  {
    id: 13,
    name: "Manage_Roles",
    description: "Permission to create, edit, delete, and assign permissions to roles",
    type: "Role & Permission Management",
    dependencies: ["View_Roles"]
  },
  {
    id: 14,
    name: "View_Permissions",
    description: "Permission to view system permissions",
    type: "Role & Permission Management",
    dependencies: []
  },
  {
    id: 15,
    name: "Manage_Permissions",
    description: "Permission to create, edit, and delete system permissions",
    type: "Role & Permission Management",
    dependencies: ["View_Permissions"]
  },
  {
    id: 16,
    name: "View_Payment_History",
    description: "Permission to view payment history",
    type: "Financial Management",
    dependencies: []
  },
  {
    id: 17,
    name: "View_Subscriptions",
    description: "Permission to view subscription plans",
    type: "Financial Management",
    dependencies: []
  },
  {
    id: 18,
    name: "Manage_Payments",
    description: "Permission to process payments and generate invoices",
    type: "Financial Management",
    dependencies: ["View_Payment_History", "View_Subscriptions"]
  }
];

export default backupPermissions;